import React from 'react';

import NoResultsIcon from 'icons/noresults-xl.svg';
import { Trans, useTranslation } from 'react-i18next';

export default function MasterCoshhSearchBlankNotice({ masterCoshhSearch }) {
  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  return (
    <section className='section section--notice section--flush tw-border-grey-100 tw-bg-white tw-py-20'>
      <NoResultsIcon
        className='[&_path]:tw-fill-grey-300'
        height={64}
        width={64}
      />
      <h2 className='section__header tw-pt-0 tw-text-l tw-font-semibold tw-text-grey-900'>
        {i18nTShared('noResultsFoundForSearch', {
          interpolation: { escapeValue: false },
          search: masterCoshhSearch,
        })}
      </h2>
      <p className='section__content tw-mb-0 tw-mt-2'>
        <Trans
          components={{
            a: (
              /* eslint-disable jsx-a11y/anchor-has-content */
              <a
                className='app-link tw-align-baseline tw-text-blue-500 hover:tw-text-blue-300 active:tw-text-blue-300'
                href='mailto:help@handshq.com'
              />
            ),
            /* eslint-enable jsx-a11y/anchor-has-content */
          }}
          i18nKey='masterCoshh.components.MasterCoshhSearchBlankNotice.description'
          ns='components'
        />
      </p>
    </section>
  );
}
